import actionCreatorFactory from 'typescript-fsa';
import {DeviceUser, Devices, FileParameter} from '../../../api/api';
import {constants} from './constants';

const actionCreator = actionCreatorFactory('devices');

export const getDeviceContentAction = actionCreator.async<void, Devices[]>(constants.GetDeviceContent);
export const getDevicesAction = actionCreator.async<void, Devices[]>(constants.GetDevices);
export const getUserDeviceContentAction = actionCreator.async<void, Devices[]>(constants.GetUserDevices);
export const selectDeviceAction = actionCreator<string>(constants.SelectDevice);

export const SetDeviceDatesAction = actionCreator<{
  dateFrom: Date;
  dateTo: Date;
}>(constants.SetDeviceDates);

export const selectAllAction = actionCreator(constants.SelectAllDevices);

export const updateCalibrationFactor = actionCreator.async<{calibrationFactor: number; deviceId: string}, Devices>(
  constants.UpdateCalibrationFactor,
);

export const updateSpectral = actionCreator.async<{spectralMeasurement: number; deviceId: string}, Devices>(
  constants.UpdateSpectralMeasurement,
);

export const updateLabMeasurement = actionCreator.async<{labMeasurement: number; deviceId: string}, Devices>(
  constants.UpdateLabMeasurement,
);

export const updateStationId = actionCreator.async<{stationId: string; deviceId: string}, Devices>(
  constants.UpdateStationId,
);

export const calibrateDeviceAction = actionCreator.async<{timeOfMeasurement: Date; deviceId: string}, Devices>(
  constants.CalibrateDevice,
);

export const updateSpectralMeasurementDateTime = actionCreator.async<
  {measurementDate: Date | undefined; deviceId: string},
  Devices
>(constants.UpdateSpectralMeasurementDate);

export const deleteUserDeviceAction = actionCreator.async<{deviceId: string; userId: string}, void>(
  constants.DeleteUserDevice,
);

export const addUserDeviceAction = actionCreator.async<{deviceId: string; userId: string}, DeviceUser>(
  constants.AddUserDevice,
);

export const uploadCsvAction = actionCreator.async<{deviceId: string; file: FileParameter}, void>(constants.UploadCsv);
